<script setup lang="ts">

</script>

<template>
<img class="altra-icon" src="/icon.png" alt="AltraCare">
</template>

<style lang="scss" scoped>

</style>